import React, { useRef } from "react";
import AddToCart from "../AddToCart";
import { translate } from "../../Services/translation";
import { Price, StockStatus, Td, Th, Tr, VariantMeta } from "./TableSubComponents";
import AccessoriesTriggerButton from "./AccessoriesTriggerButton";
import { useSelector } from "react-redux";
import BuyButton from "../BuyButton";
import AddToFavorites from "../Favorites/AddToFavorites";

/**
 *
 * @param {ProductItem} variant
 * @param tableRef
 * @param {boolean} showPrices
 * @param {number} windowWidth
 * @param {boolean} showQuantityCol
 * @param {array} tableHeaders
 * @param variantAccessoriesOpen
 * @returns {JSX.Element}
 * @constructor
 */
const VariantRow = ({ variant, tableRef, showPrices, windowWidth, showQuantityCol, showAccessoriesCol, tableHeaders }) => {
    const DynamicRow = ({data}) => {
        let prop = data.prop.toLowerCase();
        let field = variant.variantTableData.find(x => x.prop === data.prop);
        if (!field || !field.stringValue || field.stringValue.trim() === '') return null;

        return (
            <Tr suffix={prop}>
                <Th>{data.label}</Th>
                <Td>{field.stringValue}</Td>
            </Tr>
        );
    }

    const variantTableState = useSelector((state) => state.variantTable);
    const variantAccessoriesOpen = variantTableState.accessoryOpen != null;
    const rowRef = useRef(null);
    const hasAccessories = variant?.accessories && variant?.accessories.length > 0;
    const selectedVariantId = variantTableState.queryParams.selectedVariant;
    const isSelectedVariant = selectedVariantId === variant.id;
    const isQuotationProduct = variant?.hidePrice || (!variant?.price?.hasPrice) || (variant?.price?.hasPrice && variant?.price?.price?.price === 0);

    return (
        <Tr clean={true} refVar={rowRef}>
            <Td className='no-border' clean={true}>
                <table className='variant-table__item' cellSpacing={0}>
                    <tbody>
                        <Tr suffix='articlenr-and-name'>
                            <Th>{translate('nmas.product.table.header.articledescription')}</Th>
                            <Td suffix='articlenr-and-name'>
                                <VariantMeta variant={variant}/>
                                <a className={'variant-table__article-nr' + (isSelectedVariant ? ' no-link' : '')} href={isSelectedVariant ? null : variant.selectedVariantUrl}>{variant.vismaArticleNumber?.length ? variant.vismaArticleNumber : variant.id}</a>
                                <div className='variant-table__article-name'>{variant.name}</div>
                            </Td>
                        </Tr>

                        {tableHeaders.length > 0 && tableHeaders.map(data => (
                            <DynamicRow {...{data}} key={`data-${data.prop.toLowerCase()}`}/>
                        ))}

                        {showAccessoriesCol && hasAccessories && <Tr suffix='accessories'>
                            <Th>{translate('nmas.product.table.header.accessories')}</Th>
                            <Td><AccessoriesTriggerButton {...{tableRef, rowRef, variant, variantAccessoriesOpen}} /></Td>
                        </Tr>}

                        <Tr suffix='stock'>
                            <Th>{translate('nmas.product.table.header.inventory')}</Th>
                            <Td><StockStatus variant={variant}/></Td>
                        </Tr>

                        {showPrices && <Tr suffix='price'>
                            <Th>{translate('nmas.product.table.header.price')}</Th>
                            <Td>{isQuotationProduct ? translate('nmas.product.price.on.request') : (!variant.isInStock && variant.replacementProductText ? translate('nmas.product.price.outofstock') : <Price priceModel={variant.price || null}/>)}</Td>
                        </Tr>}

                        {showQuantityCol && (
                            <Tr suffix={'quantity'}>
                                <Td suffix='quantity' colSpan={2}>
                                    {variant.isAnonymousUser ? (
                                        <BuyButton label={translate('nmas.product.price.login')} href={variant.loginUrl} cssClass="button button--sm" />
                                    ) : (
                                        <>
                                            <AddToCart variant={variant} isQuotationProduct={isQuotationProduct} />
                                            <AddToFavorites {...{ variant }}/>
                                        </>
                                    )}
                                </Td>
                            </Tr>
                        )}
                    </tbody>
                </table>
            </Td>
        </Tr>
    );
}

export default VariantRow;